import React from "react";

/**
 * Propriedades para o componente DocumentViewer.
 */
interface DocumentViewerProps {
  /** A URL do documento a ser exibido. */
  url: string;
  /** O título do documento, usado para acessibilidade (ex: título do iframe). */
  title?: string;
  /** A altura do visualizador. Padrão é '600px'. */
  height?: string;
}

/**
 * `DocumentViewer` é um componente para exibir diferentes tipos de documentos (PDF, PNG, JPG)
 * diretamente na página. Ele determina o tipo de arquivo a partir da extensão da URL.
 *
 * @param {DocumentViewerProps} props - As propriedades do componente.
 * @returns {React.FC} Um componente funcional React que renderiza o visualizador de documentos.
 */
const DocumentViewer: React.FC<DocumentViewerProps> = ({
  url,
  title = "Visualizador de Documentos",
  height = "600px",
}) => {
  if (!url) {
    return <div>URL do documento não fornecida.</div>;
  }

  const getFileExtension = (fileUrl: string) => {
    try {
      // Tenta extrair a extensão de uma URL completa
      const urlObject = new URL(fileUrl);
      const pathname = urlObject.pathname;
      return pathname.split(".").pop()?.toLowerCase() || "";
    } catch (error) {
      // Fallback para URLs relativas ou malformadas
      return fileUrl.split(".").pop()?.toLowerCase() || "";
    }
  };

  const fileExtension = getFileExtension(url);

  const isImage = ["png", "jpg", "jpeg", "gif", "bmp", "webp"].includes(
    fileExtension
  );
  const isPdf = fileExtension === "pdf";

  if (isImage) {
    return (
      <img src={url} alt={title} style={{ maxWidth: "100%", height: "auto" }} />
    );
  }

  if (isPdf) {
    return (
      <iframe
        src={`${url}#navpanes=0`}
        title={title}
        width="100%"
        height="90%"
        style={{ border: "1px solid #ccc" }}
      />
    );
  }

  return (
    <img
      src={url}
      width="100%"
      height="auto"
      title="Invoice"
      style={{ border: "none" }}
    ></img>
  );
};

export default DocumentViewer;
